module.exports = __webpack_public_path__ + "img/logo-flextd.cc310472.svg";